import { Typography } from '@mui/material'
import OtpInputField from '../../../UtilityComponents/OTPInputField/OTPInputField'
import GGButton from '../../../CommonComponents/GGButton/GGButton';
import successLottie from '../../../../assets/lottie_animations/success-lottie.json';
import loaderLottie from '../../../../assets/lottie_animations/bubble-loader.json';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import { useRegistrationOtpVerification } from '../hooks/useRegistrationOtpVerification';
import { OTP_LENGTH } from '../../../../enums/AuthFlowEnums';

interface VerifyEmailWithOtpComponentProps {
    email: string,
    name: string,
    password: string,
    /** Bot-trap value captured on the registration form. */
    honeypot?: string,
    componentDismiss: () => void
}

const VerifyEmailAndRegisterComponent = ({ email, name, password, honeypot, componentDismiss }: VerifyEmailWithOtpComponentProps) => {
    const navigate = useNavigate()
    const {
        otp, setOtp, error, isLoading, isResending, hasRegistered,
        canResend, resendButtonText, verifyOtpAndRegister, resendOtp,
    } = useRegistrationOtpVerification({ email, name, password, honeypot, onRegistered: () => navigate("/") });

    return (
        <div className='forgot-password-otp-input-page'>
            {hasRegistered ?
                <>
                    <Lottie className="success-lottie" animationData={successLottie} loop={true}></Lottie>
                    <Typography fontWeight={1000} marginBottom={"15px"}>Congratulations {name} for becoming a part of GenieGig! <br /> <i>Logging you in now. </i></Typography>
                </> :
                <>
                    <Typography>Please verify your email by entering the OTP sent to your email: <b>{email}</b> </Typography>
                    <Typography variant='subtitle2'><i>Note: Please check your spam section as well for the verification mail. </i></Typography>
                    <OtpInputField onChangeOtp={setOtp} length={OTP_LENGTH} />
                    <Typography variant='caption' sx={{ color: 'red' }}>{error}</Typography>
                    {
                        isLoading ?
                            <Lottie className="loader-lottie" animationData={loaderLottie} loop={true}></Lottie> :
                            <div className='button-section'>
                                <GGButton className='btn-secondary' onClick={componentDismiss}>
                                    Go Back
                                </GGButton>

                                <GGButton className='btn-primary' onClick={verifyOtpAndRegister} disabled={otp.length !== OTP_LENGTH}>
                                    Verify OTP & Register
                                </GGButton>
                            </div>

                    }
                    <GGButton variant='text' disabled={!canResend || isResending} onClick={resendOtp}> <Typography fontFamily={'arial'}> {resendButtonText} </Typography>  </GGButton>
                </>
            }


        </div>
    )
}

export default VerifyEmailAndRegisterComponent